const dev = {
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://wvrw0e4oa4.execute-api.eu-west-2.amazonaws.com/prod/",
  },
};

const prod = {
  apiGateway: {
    REGION: "eu-west-2",
    URL: "https://wvrw0e4oa4.execute-api.eu-west-2.amazonaws.com/prod/",
  },
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === "prod" ? prod : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
